export default __webpack_public_path__ + "static/media/4.800e3159.jpg";